import type { StatCardProps } from "@/components/molecules/StatCard";
import {
  User,
  Profile2User,
  Moneys,
  Flag,
  ReceiptMinus,
  NotificationBing,
} from "iconsax-react";

export interface ActivityItem {
  type: "group" | "user" | "chat" | "payment";
  title: string;
  subtitle: string;
  detail?: string;
  timestamp: string;
}

export interface DashboardGroup {
  name: string;
  creator: string;
  type: "Free" | "Paid";
  price?: number;
  usersJoined: number;
  revenue: number;
  status: "Active" | "Expired";
}

export interface TopGroup {
  name: string;
  creator: string;
  revenue: number;
  users?: number;
  isFree?: boolean;
}

export interface ChartDataPoint {
  day: string;
  value: number;
}

export const PLATFORM_STATS: StatCardProps[] = [
  {
    title: "Total User",
    value: "12,745",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Active Users (Last 7D)",
    value: "3,921",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "decrease" },
  },
  {
    title: "Groups Created Today",
    value: "43",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Revenue This Month",
    value: "$2,160",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Pending Payouts",
    value: "$320",
    icon: <ReceiptMinus variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "New Reports",
    value: "7",
    icon: (
      <NotificationBing variant="Bold" color="#484848" className="w-6 h-6" />
    ),
    trend: { value: "+2 cases", type: "increase" },
  },
];

export const REVENUE_STATS: StatCardProps[] = [
  {
    title: "Total Revenue",
    value: "$12,745",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Platform Commission",
    value: "$648",
    icon: <Flag variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Paid to Creators",
    value: "$243",
    icon: <User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
];

export const ACTIVITIES: ActivityItem[] = [
  {
    type: "group",
    title: "Techies Lunch Meetup",
    subtitle: "New York - Created By @joyreed",
    detail: "Free",
    timestamp: "10 min ago",
  },
  {
    type: "user",
    title: "Diana U.",
    subtitle: "Cape Town",
    timestamp: "10 min ago",
  },
  {
    type: "chat",
    title: "@michael ❤️ @jane_sparks",
    subtitle: "Matched",
    timestamp: "10 min ago",
  },
  {
    type: "payment",
    title: '$3 to join "Paint & Chill" group',
    subtitle: "New York - Created By @joyreed",
    detail: "$3",
    timestamp: "10 min ago",
  },
];

export const DASHBOARD_GROUPS: DashboardGroup[] = [
  {
    name: "Yoga & Tea Mornings",
    creator: "@wellnessgirl",
    type: "Paid",
    price: 2,
    usersJoined: 31,
    revenue: 62,
    status: "Expired",
  },
  {
    name: "Book Club Night",
    creator: "@tony_reads",
    type: "Free",
    usersJoined: 22,
    revenue: 0,
    status: "Active",
  },
  {
    name: "Salsa Singles Night",
    creator: "@dance_africa",
    type: "Paid",
    price: 3,
    usersJoined: 19,
    revenue: 57,
    status: "Active",
  },
  {
    name: "Hiking in Lekki",
    creator: "@adventurer_kate",
    type: "Paid",
    price: 1,
    usersJoined: 16,
    revenue: 16,
    status: "Expired",
  },
];

export const TOP_PERFORMING_GROUPS: TopGroup[] = [
  {
    name: "Yoga & Tea Mornings",
    creator: "@joyreed",
    users: 23,
    isFree: true,
    revenue: 0,
  },
  {
    name: "Yoga & Tea Mornings",
    creator: "@joyreed",
    users: 23,
    isFree: true,
    revenue: 0,
  },
  { name: "Yoga & Tea Mornings", creator: "@joyreed", users: 23, revenue: 63 },
  { name: "Yoga & Tea Mornings", creator: "@joyreed", users: 23, revenue: 63 },
];

export const TOP_EARNING_GROUPS: TopGroup[] = [
  { name: "Yoga & Tea Mornings", creator: "@joyreed", revenue: 1000 },
  { name: "Yoga & Tea Mornings", creator: "@joyreed", revenue: 1000 },
  { name: "Yoga & Tea Mornings", creator: "@joyreed", revenue: 1000 },
  { name: "Yoga & Tea Mornings", creator: "@joyreed", revenue: 1000 },
];

export const CHART_DATA: ChartDataPoint[] = [
  { day: "Mon", value: 650 },
  { day: "Tue", value: 900 },
  { day: "Wed", value: 700 },
  { day: "Thu", value: 400 },
  { day: "Fri", value: 500 },
  { day: "Sat", value: 600 },
  { day: "Sun", value: 750 },
];
